import React from "react";
import useFilteredBillingTypes, {
  getProjectStorageBillingTypeOptions,
} from "../../../../hooks/useFilteredBillingTypes";
import SelectField from "../SelectField";

const BillingTypeField = ({ entity, ...props }) => {
  const projectBillingTypeOptions = entity?.project
    ? getProjectStorageBillingTypeOptions(entity.project.billingTypes)
    : null;
  const filteredOptions = useFilteredBillingTypes(projectBillingTypeOptions);
  return <SelectField {...props} options={filteredOptions} />;
};

export default BillingTypeField;
